<table class="table table-connectpay">
  <thead>
    <tr>
      <th>Name</th>
      <th>Date Requested</th>
      <th>Request Type</th>
      <th>Manage Request</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let request of requests">
      <td>{{ request.RequesterName }}</td>
      <td>{{ request.LastModifiedDate | date: 'MM/dd/YY' }}</td>
      <td>{{ request.RequestType }}</td>
      <td>
        <button (click)="viewRequest(request)" class="btn btn-tertiary request-button">
          Review Change
        </button>
      </td>
    </tr>
  </tbody>
</table>
<lib-address-change-modal
  *ngIf="changeRequestData != null"
  [changeRequest]="selectedRequest"
  [addressChangeRequestData]="changeRequestData"
  (modalClosed)="modalClosed($event)"></lib-address-change-modal>
<lib-direct-deposit-change-review-modal
  *ngIf="directDepositRequestData != null"
  [changeRequest]="selectedRequest"
  [changeRequestData]="directDepositRequestData"
  [readonly]="false"
  [allowDecision]="true"
  (modalClosed)="modalClosed($event)"></lib-direct-deposit-change-review-modal>
